var _gallection;
export const isPremiumGallection = (gallection)=>!!((_gallection = gallection) === null || _gallection === void 0 ? void 0 : _gallection.premiumFolderData);
export const getPremiumGallectionType = (gallection)=>{
    var _gallection_premiumFolderData, _gallection;
    return (_gallection_premiumFolderData = (_gallection = gallection) === null || _gallection === void 0 ? void 0 : _gallection.premiumFolderData) === null || _gallection_premiumFolderData === void 0 ? void 0 : _gallection_premiumFolderData.type;
};
